(() => {
  const instances = new Map();
  class ProductOverviewPlayer {
    constructor(root) {
      this.root = root;
      this.video = root.querySelector('[data-pilot-video]');
      this.controls = root.querySelector('[data-product-video-controls]');
      this.playButton = this.controls.querySelector('[data-video-play]');
      this.soundButton = this.controls.querySelector('[data-video-sound]');
      this.status = this.controls.querySelector('[data-video-status]');
      this.active = !this.video.hidden;
      this.visible = false;
      this.userPaused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.finished = false;
      this.autoplayAttempted = false;
      this.abort = new AbortController();
      this.video.controls = false;
      this.video.loop = this.video.muted;
      this.controls.hidden = !this.active;
      this.on(this.playButton, 'click', () => {
        if (this.video.paused) { this.userPaused = false; this.play(); }
        else { this.userPaused = true; this.video.pause(); }
      });
      this.on(this.soundButton, 'click', () => {
        if (this.video.muted) {
          this.video.currentTime = 0;
          this.video.muted = false;
          this.video.loop = false;
          this.userPaused = false;
          this.play();
        } else {
          this.video.muted = true;
          this.video.loop = true;
        }
        this.sync();
      });
      this.on(this.controls.querySelector('[data-video-replay]'), 'click', () => {
        this.video.currentTime = 0;
        this.userPaused = false;
        this.play();
      });
      ['play','pause','volumechange','loadedmetadata'].forEach(type => this.on(this.video, type, () => this.sync()));
      this.on(this.video, 'ended', () => { this.finished = true; this.userPaused = true; this.sync(); });
      this.on(this.video, 'error', () => { this.status.textContent = this.controls.dataset.errorHint; this.sync(); });
      this.on(this.video, 'timeupdate', () => {
        const ratio = this.video.duration ? this.video.currentTime / this.video.duration : 0;
        this.controls.querySelector('[data-video-progress]').style.transform = `scaleX(${Math.min(1, ratio)})`;
      });
      this.on(root, 'product-media:change', event => {
        this.active = event.detail.videoActive;
        this.controls.hidden = !this.active;
        this.updateVisibility();
      });
      this.on(document, 'visibilitychange', () => this.updateVisibility());
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.25;
        this.updateVisibility();
      }, {threshold: [0, 0.25, 0.5]});
      this.observer.observe(this.video.parentElement);
      this.sync();
      root.dataset.productPlayerReady = 'true';
    }
    on(target, type, listener) { target.addEventListener(type, listener, {signal: this.abort.signal}); }
    play() {
      if (!this.active) return;
      this.finished = false;
      this.status.textContent = '';
      const promise = this.video.play();
      if (promise) promise.catch(() => {
        this.status.textContent = this.controls.dataset.pausedHint;
        this.sync();
      });
    }
    updateVisibility() {
      if (!this.active || !this.visible || document.hidden) this.video.pause();
      else if (!this.userPaused && !this.finished) {
        if (!this.autoplayAttempted) {
          this.autoplayAttempted = true;
          this.video.muted = false;
          this.video.loop = false;
          const attempt = this.video.play();
          if (attempt) attempt.catch(() => {
            // Browser autoplay policies require muted playback until a user gesture.
            this.video.muted = true;
            this.video.loop = true;
            if (this.active && this.visible && !document.hidden && !this.userPaused) this.play();
            this.sync();
          });
        } else this.play();
      }
    }
    sync() {
      const paused = this.video.paused;
      const label = paused ? this.playButton.dataset.playLabel : this.playButton.dataset.pauseLabel;
      this.playButton.setAttribute('aria-label', label);
      this.playButton.title = label;
      this.playButton.querySelector('[data-icon-play]').toggleAttribute('hidden', !paused);
      this.playButton.querySelector('[data-icon-pause]').toggleAttribute('hidden', paused);
      this.soundButton.querySelector('[data-sound-label]').textContent = this.video.muted ? this.soundButton.dataset.onLabel : this.soundButton.dataset.offLabel;
      this.soundButton.setAttribute('aria-pressed', String(!this.video.muted));
      if (!this.soundHint) this.soundHint = this.soundButton.title;
      this.soundButton.title = this.video.muted ? this.soundHint : this.soundButton.dataset.offLabel;
    }
    destroy() { this.video.pause(); this.abort.abort(); this.observer.disconnect(); instances.delete(this.root); }
  }
  function initialize(container = document) {
    container.querySelectorAll('[data-pilot-gallery]').forEach(root => {
      if (!instances.has(root) && root.querySelector('[data-pilot-video]') && root.querySelector('[data-product-video-controls]')) instances.set(root, new ProductOverviewPlayer(root));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach(player => { if (event.target.contains(player.root)) player.destroy(); });
  });
})();
